import * as React from 'react';

import { createQueryHook } from '~/shared/providers/api';

const useSupplierAccountQuery = createQueryHook(
  'trade.supplierAccountById',
  (params: { accountIds: string[] }) => ({
    accounts: {
      __args: {
        filter: {
          ids: params.accountIds,
          isSupplier: true,
        },
      },
      page: {
        __scalar: true,
      },
      entries: {
        id: true,
        name: true,
        addresses: {
          id: true,
          name: true,
          address: {
            __scalar: true,
          },
        },
        contacts: {
          id: true,
          __scalar: true,
        },
      },
    },
  }),
  {
    select: (data) => data?.accounts.entries ?? [],
  },
);

export const useSupplierAccount = (accountId: string | null | undefined) => {
  const { data: accountsQueryData } = useSupplierAccountQuery({
    accountIds: accountId ? [accountId] : [],
    queryOptions: {
      enabled: !!accountId,
    },
  });

  const selectedAccount = React.useMemo(
    () => accountsQueryData?.find((account) => account.id === accountId),
    [accountsQueryData, accountId],
  );

  return { selectedAccount, accountsQueryData };
};
